import { NodeSummary, Knot, SubscriptionStatus } from "./query";
import { ApiResponse } from "./localDb";

const API_BASE = "https://cv03-server.kamn-miller.workers.dev/api";
const DEFAULT_HEADERS = {
    "Content-Type": "application/json"
};

// Helper functions
const buildUrl = (path: string, params?: Record<string, any>) => {
    const url = `${API_BASE}${path}`;
    if (!params) return url;
    
    const queryString = Object.entries(params)
        .filter(([_, value]) => value != null && value !== '')
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
        
    return queryString ? `${url}?${queryString}` : url;
};

const apiFetch = async <T>(path: string, token: string, options?: RequestInit): Promise<T> => {
    const headers = {
        ...DEFAULT_HEADERS,
        "Authorization": `Bearer ${token}`
    };

    const response = await fetch(path, {
        headers,
        ...options
    });
    
    if (!response.ok) {
        throw new Error(`API Error: ${response.statusText}`);
    }
    
    return response.json();
};

// Node APIs
export const getNodes = async (searchParam: string, token: string, pageParam: number) => 
    apiFetch<ApiResponse<NodeSummary>>(buildUrl('/nodes', { search: searchParam, cursor: pageParam }), token);

export const getNode = async (id: string, token: string) => 
    apiFetch<NodeSummary>(buildUrl(`/nodes/${id}`), token);

export const addNode = async (data: unknown, token: string) => 
    apiFetch(buildUrl('/nodes'), token, { method: 'POST', body: JSON.stringify(data) });

export const deleteNode = async (id: string, token: string) => 
    apiFetch(buildUrl(`/nodes/${id}`), token, { method: 'DELETE' });

export const editNode = async (nodeId: string, token: string, newNode: NodeSummary) => 
    apiFetch(buildUrl(`/nodes/${nodeId}`), token, { method: 'PATCH', body: JSON.stringify(newNode) });

// Knot APIs
export const getKnots = async (nodeId: string, token: string, searchParam: string, pageParam: number) => 
    apiFetch<ApiResponse<Knot>>(buildUrl('/knots', { nodeId, search: searchParam, cursor: pageParam }), token);

export const addKnot = async (data: unknown, token: string) => 
    apiFetch(buildUrl('/knots'), token, { method: 'POST', body: JSON.stringify(data) });

// Subscription APIs remain unchanged
export const getSubscriptionStatus = async (): Promise<SubscriptionStatus> => 
    ({ status: "active" });

export const mergeNodes = async (ids: string[], token: string) => {
    console.log("Global mergeNodes", ids);
};